import { render, staticRenderFns } from "./EvatStatusChip.vue?vue&type=template&id=3d828180&scoped=true"
import script from "./EvatStatusChip.vue?vue&type=script&lang=js"
export * from "./EvatStatusChip.vue?vue&type=script&lang=js"
import style0 from "./EvatStatusChip.vue?vue&type=style&index=0&id=3d828180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d828180",
  null
  
)

export default component.exports